import { render, staticRenderFns } from "./MatterDescriptorsContainer.vue?vue&type=template&id=111d5ddc&scoped=true"
import script from "./MatterDescriptorsContainer.vue?vue&type=script&lang=js"
export * from "./MatterDescriptorsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111d5ddc",
  null
  
)

export default component.exports